import { IconShieldCheck } from '@tabler/icons-react'
import { useConsent } from '../../context/ConsentContext.tsx'

export function CookieConsentBanner() {
  const { choice, accept, reject } = useConsent()

  if (choice !== null) return null

  return (
    <div className="fixed bottom-0 inset-x-0 z-[700] flex justify-center px-4 pb-4 pointer-events-none">
      <div
        className="pointer-events-auto w-full max-w-2xl rounded-xl shadow-lg border border-black/10
                   bg-brand-orange text-black
                   flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4 px-5 py-4"
      >
        <IconShieldCheck size={20} className="shrink-0 hidden sm:block text-black/70" />

        <p className="flex-1 text-sm leading-relaxed text-black/85">
          GearLocker uses cookies mainly to catch errors and keep the app running smoothly,
          and secondarily for basic usage insights. No cookies are set until you accept.
        </p>

        <div className="flex items-center gap-2 shrink-0">
          <button
            onClick={reject}
            className="px-3 py-1.5 rounded-lg text-sm font-medium text-black/70 hover:text-black
                       hover:bg-black/5 transition-colors"
          >
            Reject
          </button>
          <button
            onClick={accept}
            className="px-3 py-1.5 rounded-lg text-sm font-medium bg-black text-brand-orange-light
                       hover:bg-black/85 transition-colors"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  )
}
